import { buildFolderPath, normalizeProjectPath, splitPath, } from "./build.js";
export function buildCreatePath(intent) {
    const folderPrefix = buildFolderPath({ kind: "folder", scope: intent.scope });
    const path = normalizeProjectPath(`${folderPrefix}/new/${encodeURIComponent(intent.targetEntityAlias)}`);
    return intent.presetKey ? `${path}?preset=${encodeURIComponent(intent.presetKey)}` : path;
}
export function parseCreatePath(path) {
    const [rawPath, rawSearch = ""] = path.split("?");
    const segments = splitPath(rawPath ?? "");
    if (segments.length < 3)
        return null;
    const newIndex = segments.lastIndexOf("new");
    if (newIndex < 1 || newIndex !== segments.length - 2)
        return null;
    const rootFolderSlug = decodeURIComponent(segments[0]);
    const targetEntityAlias = decodeURIComponent(segments[segments.length - 1]);
    const folderSlugs = segments.slice(1, newIndex).map((segment) => decodeURIComponent(segment));
    const searchParams = new URLSearchParams(rawSearch);
    return {
        kind: "createEntity",
        presetKey: searchParams.get("preset") ?? "",
        targetEntityTypeKey: targetEntityAlias,
        targetEntityAlias,
        scope: {
            rootFolderSlug,
            folderSlugs,
            entityLineage: [],
        },
    };
}
export function resolveActionScope(path) {
    const parsedCreate = parseCreatePath(path);
    if (parsedCreate)
        return parsedCreate.scope;
    const segments = splitPath(path);
    if (segments.length === 0) {
        return { rootFolderSlug: "", folderSlugs: [], entityLineage: [] };
    }
    return {
        rootFolderSlug: decodeURIComponent(segments[0]),
        folderSlugs: segments.slice(1).map((segment) => decodeURIComponent(segment)),
        entityLineage: [],
    };
}
export function resolveCreateDefaults(input) {
    const resolved = { ...(input.defaultValues ?? {}) };
    return resolved;
}
